/**
 * Individual medication card with dark header and lighter body.
 * Used in MedsTab to render each medication entry.
 */
import { FC } from 'react'

interface MedicationCardProps {
  name: string
  rationale?: string
}

export const MedicationCard: FC<MedicationCardProps> = ({ name, rationale }) => (
  <div className="rounded-lg border border-border overflow-hidden">
    <div className="bg-muted px-3 py-2">
      <span className="text-sm font-semibold text-foreground">{name}</span>
    </div>
    {rationale && (
      <div className="bg-card px-3 py-2">
        <p className="text-xs text-muted-foreground leading-relaxed">{rationale}</p>
      </div>
    )}
  </div>
)
